export var EPIC_END = '@@redux-observable/EPIC_END';


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/lib/es/EPIC_END.js
// module id = 610
// module chunks = 0